<vl-region>
    <vl-layout>
        <vl-form-grid mod-stacked>
            <vl-column>
                <vl-title tag-name="h2">Type aanvraag</vl-title>
            </vl-column>
            <vl-column>
                <vl-radio-tile v-for="(currentType, key) in maprequestTypes" :value="currentType.key"
                               :id="'maprequest-type-' + key" :key="'maprequest-type-' + key" v-model="maprequestType"
                               :title="currentType.title" :info="currentType.description" />
            </vl-column>
        </vl-form-grid>
        <vl-u-spacer mod-large />
        <vl-button ref="goToStep2" @click="gotoStep2" :mod-disabled="!maprequestType" mod-large>
            Volgende
        </vl-button>
    </vl-layout>
</vl-region>
